import { createContext, useContext, useState, useEffect } from 'react';
import { CustomProvider } from 'base/src/utils/routeUtil';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';

import { GetCarteiraBase } from '../../store/_carteira/carteiraBase/actions/carteiraBaseAction';
import { RootStateBaseCarteira } from '../../store/_carteira/carteiraBaseReducer';

interface CarteiraContextType {
  walletBalance: number | null;
  loading: boolean;
  fetchBalance: () => Promise<void>;
}

const CarteiraContext = createContext<CarteiraContextType | undefined>(undefined);

// Interface genérica que pode ser implementada por diferentes projetos que tenham HomeInfoReducer


const connector = connectUtil(
  (state: RootStateBaseCarteira) => ({
    homeInfo: state.CarteiraBaseReducer.CarteiraBase,
    carteiraUsuario: state.CarteiraBaseReducer.CarteiraUsuario,
  }),
  { GetCarteiraBase }
);
 
 
 
interface WalletProviderProps extends CustomProvider, PropsFromRedux<typeof connector> {
}

function CarteiraBaseProvider(props: WalletProviderProps) {
  const [walletBalance, setWalletBalance] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  async function fetchBalance() {
    if (!props.carteiraUsuario || props.carteiraUsuario.length === 0) {
      return;
    }
    setLoading(true);
    props.GetCarteiraBase(props.carteiraUsuario[0].CarteiraID);
  }

  useEffect(() => {
    window.addEventListener("balanceUpdated", fetchBalance);
    return () => {
      window.removeEventListener("balanceUpdated", fetchBalance);
    };
  }, []);

  useEffect(() => {
    if (props.carteiraUsuario && props.carteiraUsuario.length > 0) {
      fetchBalance();
    }
  }, [props.carteiraUsuario]);

  useEffect(() => {
    if (props.homeInfo == null) { return }
    setWalletBalance(props.homeInfo.BalancoAtual ?? null);
    setLoading(false);
  }, [props.homeInfo]);

  return (
    <CarteiraContext.Provider value={{ walletBalance, loading, fetchBalance }}>
      {props.children}
    </CarteiraContext.Provider>
  );
}

export function useCarteira() {
  const context = useContext(CarteiraContext);
  if (!context) {
    throw new Error('useCarteira deve ser usado dentro de um CarteiraProvider');
  }
  return context;
}

export default connector(CarteiraBaseProvider);